// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1xLOa","rightAdornment":"Header_rightAdornment__1JeP7"};